const welcome = 'welcome'

const setWelcome = () => localStorage.setItem(welcome, 'yes')

const getWelcome = () => {
    let data = localStorage.getItem(welcome)
    if (data !== '' && data !== null ) return false
    else return true
}

export {
    setWelcome,
    getWelcome,
}